export class BaseSearchFilter {
    NPINo!: string;
    fromDate!: any;
    toDate!: any;
    startDate!:string;
    endDate!:string;
}